/**
 * `AccountOptedInIndustryTaxonomy` is opt-out: unset or `true` keeps Industry Plus taxonomy; only an
 * explicit `false` keeps the legacy industry filter.
 */
export const isAccountOptedInIndustryTaxonomy = (value: string | null | undefined): boolean =>
    value?.toLowerCase() !== "false";
